import React, { useContext, useEffect, useState } from "react";

import {
  Paper,
  makeStyles,
  Box,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Tooltip,
  Button,
  Menu,
  TextField,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  TableContainer,
  InputAdornment,
  Grid,
  useTheme,
} from "@material-ui/core";

import { Pagination } from "@material-ui/lab";
import SearchIcon from "@material-ui/icons/Search";
import FilterListIcon from "@material-ui/icons/FilterList";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { useDispatch, useSelector } from "react-redux";
import {
  getSystemLogs,
  getModules,
  getOperations,
} from "../../store/action/systemLogs/systemLogsAction";

import EnhancedTableHead from "./EnhancedTableHead";
import { headCells } from "./Headcells";
import moment from "moment";
import { customEnLocale } from "../../helper/customLocale";
import Loading from "../../components/Loading/Loading";
import TablePaginationControls from "../../components/TablePaginationControls";
import { ThemeContext } from "../../App";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: 20,
    background: theme.palette.background.main
  },
  formControl: {
    width: "24%",
  },
  container: {
    marginTop: "15px",
    maxHeight: "calc(100vh - 260px)",
  },
  filterBox: {
    padding: 12,
  },
  radioGroup: {
    flexDirection: "row",
  },
}));

const SystemLogs = () => {
  const theme = useTheme();
  const { mode } = useContext(ThemeContext);
  const classes = useStyle();
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(15);
  const { getSystemLogsItem, loading } = useSelector(
    (state) => state.systemLogs
  );

  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("type");
  const [searchData, setSearchData] = useState({
    search: "",
    operation: "",
    module: "",
    start_date: null,
    end_date: null,
  });
  const [operationList, setOpertationList] = useState([]);
  const [moduleList, setModuleList] = useState([]);
  const loginUserInfo = JSON.parse(
    window.localStorage.getItem("loginUserInfo")
  );
  const getSystemLogList = (
    pageNo = 1,
    perPage = perPage,
    search,
    operation,
    module,
    start_date,
    end_date,
    type = order,
    column_name = orderBy
  ) => {
    dispatch(
      getSystemLogs({
        pageNo,
        perPage,
        search,
        operation,
        module,
        start_date,
        end_date,
        type,
        column_name,
      })
    );
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (pageNo, value) => {
    setPage(value);
    setTimeout(
      getSystemLogList(
        value,
        perPage,
        searchData?.search,
        searchData?.operation,
        searchData?.module,
        searchData?.start_date === null ? "" : moment(searchData?.start_date).format("DD-MM-yyyy"),
        searchData?.end_date === null ? "" : moment(searchData?.end_date).format("DD-MM-yyyy"),
        order,
        orderBy
      ),
      2000
    );
  };

  const handleSearchChange = (event) => {
    const d1 = event.target.value;
    if (d1) {
      setTimeout(
        getSystemLogList(
          page,
          perPage,
          d1,
          searchData?.operation,
          searchData?.module,
          searchData?.start_date === null ? "" : moment(searchData?.start_date).format("DD-MM-yyyy"),
          searchData?.end_date === null ? "" : moment(searchData?.end_date).format("DD-MM-yyyy"),
          order,
          orderBy
        ),
        1000
      );
    } else {
      setTimeout(
        getSystemLogList(
          page,
          perPage,
          (searchData.search = ""),
          (searchData.operation = ""),
          (searchData.module = ""),
          (searchData.start_date = null),
          (searchData.end_date = null),
          order,
          orderBy
        ),
        1000
      );
    }
    setSearchData({ ...searchData, [event.target.name]: event.target.value });
  };

  const handleClickSearch = (event, value) => {
    setPage(1);
    handleMenuClose(true);
    setTimeout(
      getSystemLogList(
        page,
        perPage,
        searchData?.search,
        searchData?.operation,
        searchData?.module,
        searchData?.start_date === null ? "" : moment(searchData?.start_date).format("DD-MM-yyyy"),
        searchData?.end_date === null ? "" : moment(searchData?.end_date).format("DD-MM-yyyy"),
        order,
        orderBy
      ),
      1000
    );
  };

  const handlePerPageChange = (event) => {
    const newPerPage = event.target.value;
    setPerPage(newPerPage);
    setPage(page);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleReset = () => {
    let data = {
      search: "",
      operation: "",
      module: "",
      start_date: null,
      end_date: null,
    };
    setPage(1);
    setSearchData(data);
    handleMenuClose(true);
    setTimeout(
      getSystemLogList(
        page,
        perPage,
        (data.search = ""),
        (data.operation = ""),
        (data.module = ""),
        (data.start_date = null),
        (data.end_date = null),
        order,
        orderBy
      ),
      100
    );
  };

  const getOpertationList = async () => {
    dispatch(
      getOperations((result) => {
        if (result?.status === true) {
          setOpertationList(result);
        }
      })
    );
  };

  const getModuleList = async () => {
    dispatch(
      getModules((result) => {
        if (result?.status === true) {
          setModuleList(result);
        }
      })
    );
  };

  useEffect(() => {
    if (
      loginUserInfo?.role === "SUPERADMIN" ||
      loginUserInfo?.role === "ORGANIZATION" ||
      loginUserInfo?.is_smt === "Yes" ||
      loginUserInfo?.role === "SUPERADMIN"
    ) {
      getOpertationList();
      getModuleList();
    }
  }, []);

  useEffect(() => {
    if (
      loginUserInfo?.role === "SUPERADMIN" ||
      loginUserInfo?.role === "ORGANIZATION" ||
      loginUserInfo?.is_smt === "Yes" ||
      loginUserInfo?.role === "SUPERADMIN"
    ) {
      getSystemLogList(
        page,
        perPage,
        searchData?.search,
        searchData?.operation,
        searchData?.module,
        searchData?.start_date === null ? "" : moment(searchData?.start_date).format("DD-MM-yyyy"),
        searchData?.end_date === null ? "" : moment(searchData?.end_date).format("DD-MM-yyyy"),
        order,
        orderBy
      );
    }
  }, [dispatch, orderBy, order, perPage]);

  useEffect(() => {
    document.documentElement.style.setProperty('--bg-color', theme.palette.grey[1000]);
    document.documentElement.style.setProperty('--sticky-header', theme.palette.thead);
    document.documentElement.style.setProperty('--sticky-odd', theme.palette.background.stickyOdd);
    document.documentElement.style.setProperty('--sticky-even', theme.palette.background.stickyEven);
  }, [mode]);

  return (
    <>
      {loading && <Loading open={loading} />}

      {loginUserInfo?.role === "ORGANIZATION" ||
        loginUserInfo?.is_smt === "Yes" ||
        loginUserInfo?.role === "SUPERADMIN" ? (
        <Paper className={`${classes.root} mb-6`}>
          <Box
            mb={3}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box sx={{ display: "flex", alignItems: "center", width: "24%" }}>
              <TextField
                size="small"
                placeholder="Search now..."
                name="search"
                variant="outlined"
                onChange={handleSearchChange}
                onKeyPress={(e) => e.key === "Enter" && handleClickSearch()}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon onClick={handleClickSearch} />
                    </InputAdornment>
                  ),
                }}
                className="modernSearchField"
              />
            </Box>

            <Box sx={{ display: "flex", alignItems: "end" }}>
              <Tooltip title="Filters">
                <Button onClick={handleMenu}>
                  <FilterListIcon />
                </Button>
              </Tooltip>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                open={openMenu}
                onClose={handleMenuClose}
                className="filterBookingSearch"

              >
                <Grid container className="customPopup">
                  {/* Module */}
                  <Grid item xs={12} sm={6} md={6}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel>Modules</InputLabel>
                      <Select
                        label="Modules"
                        name="module"
                        value={searchData?.module}
                        onChange={(e) =>
                          setSearchData({ ...searchData, [e.target.name]: e.target.value })
                        }
                      >
                        <MenuItem value="">Select Module</MenuItem>
                        {moduleList?.data?.map((items, index) => (
                          <MenuItem value={items.module_name} key={index}>
                            {items.module_name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Operations */}
                  <Grid item xs={12} sm={6} md={6}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel>Operations</InputLabel>
                      <Select
                        label="Operations"
                        name="operation"
                        value={searchData?.operation}
                        onChange={(e) =>
                          setSearchData({ ...searchData, [e.target.name]: e.target.value })
                        }
                      >
                        <MenuItem value="">Select Operation</MenuItem>
                        {operationList?.data?.map((List, index) => (
                          <MenuItem value={List.type} key={index}>
                            {List.type}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Start Date */}
                  <Grid item xs={12} sm={6} md={6}>
                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      adapterLocale={customEnLocale}
                      localeText={{ start: "Check-in", end: "Check-out" }}
                    >
                      <DatePicker
                        label="Start Date"
                        // inputFormat="dd/MM/yyyy"
                        inputFormat="dd-MMM-yyyy"
                        onChange={(newValue) =>
                          setSearchData({
                            ...searchData,
                            start_date: newValue,
                          })
                        }
                        value={searchData?.start_date}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            style={{ width: "100%" }}
                            variant="outlined"
                          />
                        )}
                        firstDayOfWeek={1}
                      />
                    </LocalizationProvider>
                  </Grid>

                  {/* End Date */}
                  <Grid item xs={12} sm={6} md={6}>
                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      adapterLocale={customEnLocale}
                      localeText={{ start: "Check-in", end: "Check-out" }}
                    >
                      <DatePicker
                        label="End Date"
                        // inputFormat="dd/MM/yyyy"
                        inputFormat="dd-MMM-yyyy"
                        onChange={(newValue) =>
                          setSearchData({
                            ...searchData,
                            end_date: newValue,
                          })
                        }
                        firstDayOfWeek={1}
                        value={searchData?.end_date}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            style={{ width: "100%" }}
                            variant="outlined"
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>

                {/* Buttons */}
                <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleClickSearch}
                    style={{ marginRight: "6px" }}
                  >
                    Search
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleReset}
                  >
                    Reset
                  </Button>
                </Box>
              </Menu>
            </Box>
          </Box>
          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table">
              <EnhancedTableHead
                order={order}
                orderBy={orderBy}
                onRequestSort={(event, property) => {
                  handleRequestSort(
                    property,
                    setOrder,
                    setOrderBy,
                    orderBy,
                    order
                  );
                }}
                rowCount={getSystemLogsItem?.data?.data?.length}
                headCells={headCells[0]}
              />

              <TableBody>
                {getSystemLogsItem?.data?.data &&
                  getSystemLogsItem.data?.data.map((row, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell scope="row" style={{ color: theme.palette.listItem }}
                        >{row.id}</TableCell>
                        <TableCell align="left" style={{ color: theme.palette.listItem }}
                        >{row.type}</TableCell>
                        <TableCell align="left" style={{ color: theme.palette.listItem }}
                        >{row.module_name}</TableCell>
                        <TableCell align="left" style={{ color: theme.palette.listItem }}
                        >{row.email}</TableCell>
                        <TableCell align="left" style={{ color: theme.palette.listItem }}
                        >{row.created_by}</TableCell>
                        <TableCell align="left" style={{ color: theme.palette.listItem }}
                        >{
                            row.created_date &&
                              moment(row.created_date, "DD-MM-YYYY", true).isValid()
                              ? moment(row.created_date, "DD-MM-YYYY").format("DD-MMM-YYYY")
                              : "-"
                          }</TableCell>
                      </TableRow>
                    );
                  })}
                {!getSystemLogsItem?.data?.data?.length && (
                  <TableRow>
                    <TableCell scope="row" colSpan="6" align="center">
                      Sorry,System logs not available!
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePaginationControls
            page={page}
            rowsPerPage={perPage}
            totalRecords={getSystemLogsItem?.data?.total}
            onPageChange={handleChangePage}
            handlePerPageChange={handlePerPageChange}
          />
        </Paper >
      ) : (
        <div className="" align="center">
          <b>Sorry,You have no access!</b>
        </div>
      )}


    </>
  );
};

export default SystemLogs;
